import axios from 'axios';
import { Booking } from '../models/bookings';
import { convertFromRezdyBooking } from './rezdy';

const apiURL = import.meta.env.PROD ? '/api/' : 'http://localhost:5000/api/';

export enum BookingLookupStatus {
    FOUND = 'found',
    NOT_FOUND = 'not_found',
    ERROR = 'error',
}

export interface BookingLookupResult {
    readonly status: BookingLookupStatus;
    readonly booking?: Booking;
}

// Look up a live booking by its reference (Rezdy order number) and surname.
// The surname acts as a lightweight privacy guard so a bare ref can't expose a
// stranger's details. Returns the booking mapped into the internal model.
export const fetchLiveBooking = async (ref: string, surname: string): Promise<BookingLookupResult> => {
    const trimmedRef = (ref || '').trim();
    const trimmedSurname = (surname || '').trim();
    if (!trimmedRef || !trimmedSurname) {
        return { status: BookingLookupStatus.NOT_FOUND };
    }
    try {
        const response = await axios.get(`${apiURL}rezdy/find`, {
            params: { ref: trimmedRef, surname: trimmedSurname },
        });
        if (response.data?.found && response.data?.booking) {
            return {
                status: BookingLookupStatus.FOUND,
                booking: convertFromRezdyBooking(response.data.booking, response.data.entity),
            };
        }
        return { status: BookingLookupStatus.NOT_FOUND };
    } catch (e: any) {
        if (e?.response?.status === 404) {
            return { status: BookingLookupStatus.NOT_FOUND };
        }
        console.error('Failed to look up booking', e);
        return { status: BookingLookupStatus.ERROR };
    }
};
